export const tabsData = [
  { label: 'Profile Details', value: 'profile-management' },
  { label: 'Schedule & Appointments', value: 'manage-appointment' },
  { label: 'Manage Schedule', value: 'manage-schedule' },
];

export const ALL_TIME_SLOTS = [
  '09:00 AM',
  '09:30 AM',
  '10:00 AM',
  '10:30 AM',
  '11:00 AM',
  '11:30 AM',
  '12:00 PM',
  '12:30 PM',
  '01:00 PM',
  '01:30 PM',
  '02:00 PM',
  '02:30 PM',
  '03:00 PM',
  '03:30 PM',
  '04:00 PM',
  '04:30 PM',
  '05:00 PM',
  '05:30 PM',
  '06:00 PM',
  '06:30 PM',
];

export const REPEAT_OPTIONS = [
  {
    value: 'does_not_repeat',
    label: 'Does not repeat',
  },
  {
    value: 'daily',
    label: 'Daily',
  },
  {
    value: 'weekly_on_weekends',
    label: 'Weekly on weekends',
  },
];

export const DAYS_OF_WEEK = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
